import type { DashboardScheduleEvent } from "./dashboardEventDisplay";

export type ScheduleMonthRow = {
  id: string;
  rowType: "month";
  month: string;
};

export type ScheduleEventRow = {
  id: string;
  rowType: "event";
  slug: string;
  date: DashboardScheduleEvent["date"];
  title: string;
  registration?: string;
  draft: boolean;
};

export type ScheduleTableRow = ScheduleMonthRow | ScheduleEventRow;

export function isScheduleEventRow(row: ScheduleTableRow): row is ScheduleEventRow {
  return row.rowType === "event";
}

export function buildScheduleTableRows(
  schedule: { month: string; events: DashboardScheduleEvent[] }[]
): ScheduleTableRow[] {
  return schedule.flatMap(({ month, events }) => [
    {
      id: `month-${month}`,
      rowType: "month" as const,
      month
    },
    ...events.map((event) => ({
      id: event.id,
      rowType: "event" as const,
      slug: event.slug,
      date: event.date,
      title: event.title,
      registration: event.registration,
      draft: event.draft
    }))
  ]);
}
